define(['jquery', 'c21/charts/VerticalChart', 'bootstrap'], function ($, VerticalChart) {
   "use strict";

   return function (jChartContainer, jSelect, oData, oConstructors) {
      var m_jChartContainer = jChartContainer,
         m_oData = oData,
         m_oConstructors = oConstructors,
         m_jSelect = jSelect,
         m_oSmallCharts = {},
         m_oUls = {},
         m_iTotal = 0,
         m_jSublabel;

      function getOnBoardData(strKey) {
         // Get the data value
         var strValue = m_oData[strKey],

            // Parse it into an integer
            iValue = parseInt(strValue);

         return iValue;
      }

      this.render = function () {
         var strId = m_jChartContainer.attr("id") + "Carousel",
               jCarousel = $("<div>", {
                  id: strId,
                  "class": "carousel slide visible-xs-block"
               }),
               jIndicators = $("<ol>", { "class": "carousel-indicators" }),
               jInner = $("<div>", {
                  "class": "carousel-inner",
                  "role": "listbox"
               });

         jCarousel.append(jIndicators).append(jInner);
         m_jChartContainer.append(jCarousel).addClass("cyberGraph");

         $.each(m_oConstructors, function (strKey, oOptions) {
            // Skip graphs not available on desktop
            var jOption = m_jSelect.find("option[value=" + strKey + "]");
            if (jOption.length === 0) return;

            var jUl = $("<ul>", {
                  id: "chart_" + strKey,
                  "class": "cyberVerticalGraph hidden-xs desktop graph-" + strKey
               }),
               jItem = $("<div>", {
                  "class": "item"
               }),
               jCaption = $("<div>", {
                  "class": "carousel-caption"
               }),
               jIndicator = $("<li>", {
                  "data-target": "#" + strId,
                   "data-slide-to": m_iTotal.toString()
               }),

               smallChart = new VerticalChart(jUl);

            jIndicators.append(jIndicator);

            if (m_iTotal === 0) {
               jItem.addClass("active");
               jIndicator.addClass("active");
            }

            smallChart.setMinMaxHeight(5, 120);
            smallChart.resetData();
            m_jChartContainer.append(jUl);
            $.each(oOptions.bars, function (i, oBar) {
               smallChart.addBar(oBar.title, getOnBoardData(oBar.key));
            });
            smallChart.autoAdjustViewport();
            smallChart.renderBars();

            var jUlMobile = smallChart.getMobileGraph();
            jUlMobile.addClass("graph-" + strKey);
            jItem.append(jUlMobile);
            jInner.append(jItem);

            var strCaption = jOption.text();
            jCaption.append($("<h3>").text(strCaption));
            jItem.append(jCaption);

            m_oSmallCharts[strKey] = smallChart;
            m_oUls[strKey] = jUl;

            m_iTotal++;
         });

         jCarousel.append($(
            ['<a class="left carousel-control" href="#', strId, '" role="button" data-slide="prev">',
               '<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>',
               '<span class="sr-only">Previous</span>',
            '</a>',
            '<a class="right carousel-control" href="#', strId, '" role="button" data-slide="next">',
               '<span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>',
               '<span class="sr-only">Next</span>',
            '</a>'].join('')));

         jCarousel.carousel({
            interval: false
         }).on('slide.bs.carousel', function (e) {
            var nextH = $(e.relatedTarget).outerHeight();
            $(this).find('.active.item').parent().animate({ height: nextH }, 500);
         });

         m_jSelect.change(showChart);
         showChart();
      };

      function showChart () {
         var strKey = m_jSelect.val();
         m_jChartContainer.find("ul.desktop").hide();
         m_oUls[strKey].show();

         if (m_jSublabel && (m_jSublabel.length > 0)) {
            var strText = m_oSmallCharts[strKey].getSublabel();
            m_jSublabel.html(strText);
         }
      }

      this.setSublabel = function (jSublabel) {
         m_jSublabel = jSublabel;
      };
   };
});
